
import React from "react";
import { Mail } from "lucide-react";
import { Card } from "@/components/ui/card";

interface EmptyLetterStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
}

export function EmptyLetterState({ 
  title, 
  description, 
  icon = <Mail className="h-8 w-8 text-green-500" />
}: EmptyLetterStateProps) {
  return (
    <Card className="p-10 text-center">
      <div className="mx-auto mb-4 w-16 h-16 bg-green-50 rounded-full flex items-center justify-center">
        {icon}
      </div>
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-gray-500 max-w-md mx-auto">
        {description}
      </p>
    </Card>
  );
}
